<div class="big-search-title">
  <p class="search-title">AI Song Search</p>
  <p (transitionend)="onTransitionEnd()" [class.fade]="fade()"
     class="search-subtitle transition-opacity duration-300">
    {{ mainSubtitle() }}
  </p>
</div>
